import React from 'react'
import { Alert, Descriptions, Form, FormInstance, Input } from 'antd'
import { Partner } from '../types'

type IncomingStepProps = {
  form: FormInstance
  partnerList: Partner[] | null
  /** Descriptions label for the incoming external value row (e.g. "External Color"). */
  externalRowLabel: string
  /** Extra Descriptions rows inserted before the External ID row (e.g. State's country id). */
  extraRows?: React.ReactNode
  /**
   * Field names carried through to the payload as hidden inputs. Defaults to the
   * common set; pass a custom list when a form has no integration (Age) or an
   * extra field (State's external_country_id).
   */
  hiddenFields?: string[]
}

const DEFAULT_HIDDEN_FIELDS = ['partner_key', 'name', 'external_id', 'integration_uuid']

/**
 * Read-only "Incoming" step for inbound mappings: an external value arrived from
 * the partner and isn't mapped yet, so its details are shown read-only (and carried
 * through to the payload as hidden inputs) while the user picks our side in the
 * following steps.
 */
export const IncomingStep = ({
  form,
  partnerList,
  externalRowLabel,
  extraRows,
  hiddenFields = DEFAULT_HIDDEN_FIELDS,
}: IncomingStepProps) => {
  const partnerKey = form.getFieldValue('partner_key')
  const name = form.getFieldValue('name')
  const externalId = form.getFieldValue('external_id')
  const partnerName = partnerList?.find(p => p.key === partnerKey)?.name || partnerKey

  return (
    <>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="Incoming external value"
        description="This value arrived from the external system and isn't mapped yet. The fields below are read-only — you choose the Adopets side in the next steps."
      />

      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label="Partner">{partnerName || '—'}</Descriptions.Item>
        <Descriptions.Item label={externalRowLabel}>{name || '—'}</Descriptions.Item>
        {extraRows}
        <Descriptions.Item label="External ID">{externalId || '—'}</Descriptions.Item>
      </Descriptions>

      {/* Carry the incoming values through to the payload without editable inputs. */}
      {hiddenFields.map(field => (
        <Form.Item key={field} name={field} hidden><Input /></Form.Item>
      ))}
    </>
  )
}
